type NonEmptyArray<T> = [T, ...T[]];

export const hasItemsInArray = <T>(
  data?: Array<T> | null
): data is NonEmptyArray<T> => !!data && Array.isArray(data) && data.length > 0;
